<div id="imageoneOperations" *ngIf="imageoneOperations">
    <imageone-operations [pageDisplay]="pageDisplay" [pageTitle]="pageTitle" [id]="id">
    </imageone-operations>
</div>